module.exports = __webpack_public_path__ + "e9e724957be90283314768b6825a1d56.svg";